import React from 'react';
import style from './SparkleIcon.module.css';

/**
 * AI 반짝이 아이콘 - 큰 별 + 작은 별 (그라데이션 회전)
 *
 * @param {number} size       전체 크기 (px, default 64)
 * @param {boolean} animated  회전 애니메이션 (default true)
 */
const SparkleIcon = ({ size = 64, animated = true }) => {
    return (
        <span
            className={`${style.wrap} ${animated ? style.animated : ''}`}
            style={{ width: size, height: size }}
            aria-hidden="true"
        >
            <span className={`${style.sparkle} ${style.big}`} />
            <span className={`${style.sparkle} ${style.small}`} />
        </span>
    );
};

export default SparkleIcon;